// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"d1-z","colorTextValue":"e1-z","swatches":"f1-z","collapseLink":"g1-z","isCollapsed":"h1-z","dropdown":"i1-z","disabled":"j1-z"};